
import { Component, ElementRef } from '@angular/core';
import { PageBase } from 't4core';
@Component({
  styleUrls: ['./Transactions.css'],
  selector: 'Transactions',
  templateUrl: './Transactions.html',
})
export class TransactionsComponent extends PageBase {
    constructor(el: ElementRef) {
      super(el, "Transactions");
    }
}
